import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPeriodResults } from '@interfaces/IPeriodResults';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StudentsPerformanceService {
  constructor(private _http: HttpClient) {}

  getStudentsPerformancePeriod(
    periodId: number,
    queries?: { [key: string]: string }
  ): Observable<IPeriodResults> {
    const url = `${environment.baseUrl}api/v1/periods/${periodId}/results/`;
    return this._http.get<IPeriodResults>(url, { params: queries });
  }
}
